var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { attrs: { fluid: "lg" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-overlay",
                        { attrs: { show: _vm.loading, rounded: "sm" } },
                        [
                          _c("div", { staticClass: "text-center mb-3" }, [
                            _c("img", {
                              staticClass: "mb-3 logo",
                              attrs: { src: "/imgs/logoAbelha.png", alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.user.distribuidor
                            ? _c(
                                "b-row",
                                [
                                  _vm.user.distribuidor
                                    ? _c("b-col", { attrs: { cols: "10" } }, [
                                        _c("b", [_vm._v("Distribuidor: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.user.distribuidor.codigo
                                            ) +
                                            " - " +
                                            _vm._s(_vm.user.distribuidor.nome) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { cols: "2" } }, [
                                    _c("b", [_vm._v("Classe:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.user.distribuidor.classe) +
                                        "\n                            "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c("b", [_vm._v("Usuário:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.user.name) +
                                        "\n                            "
                                    )
                                  ])
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c("h4", [
                                  _vm._v("Sua senha deve ser alterada!")
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.onSubmit.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "input-group-1",
                                            label: "Confirme seu email:",
                                            "label-for": "input-1",
                                            description:
                                              "Endereço de e-mail válido"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-1",
                                              type: "email",
                                              placeholder: "email@email.com",
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.form.email,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "email", $$v)
                                              },
                                              expression: "form.email"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "input-group-1",
                                            label: "Senha atual",
                                            "label-for": "input-1"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-current",
                                              type: "password",
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.form.current,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "current",
                                                  $$v
                                                )
                                              },
                                              expression: "form.current"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "input-group-1",
                                            label: "Nova Senha",
                                            "label-for": "input-1"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-new",
                                              type: "password",
                                              state: _vm.validation,
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.form.password,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "form.password"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: { state: _vm.validation }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.passwordError) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-valid-feedback",
                                            {
                                              attrs: { state: _vm.validation }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Senha Válida\n                                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "input-group-1",
                                            label: "Confirmação de Senha",
                                            "label-for": "input-1"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-confirm",
                                              type: "password",
                                              state: _vm.validationConfirm,
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.form.confirm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "confirm",
                                                  $$v
                                                )
                                              },
                                              expression: "form.confirm"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.validationConfirm
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            A confirmação não confere com a nova senha\n                                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "submit", variant: "primary" }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-save" }),
                                  _vm._v(" Salvar")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7abdb174", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abdb174","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/ResetPassword.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7abdb174","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/ResetPassword.vue
// module chunks = 2